import { Avatar, Menu } from '@mui/material';
import { CashRegister } from '@phosphor-icons/react/dist/ssr';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Datepicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { AiOutlineCompass, AiOutlineEye, AiTwotoneAlert } from 'react-icons/ai';
import { BiChevronDown, BiDollarCircle } from 'react-icons/bi';
import { BsEnvelope } from 'react-icons/bs';
import { HiArrowNarrowLeft } from 'react-icons/hi';
import { IoCallOutline } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, Loader } from 'src/components';
import Button from 'src/components/button';
import {
  payment_status,
  PaymentStatusButton,
} from 'src/components/payment-status';
import Table from 'src/components/table';
import useFetch from 'src/hooks/useFetch';
import { setCustomerDate } from 'src/redux/action/customer.action';
import { RootState } from 'src/redux/reducers';
import Service from 'src/setup/network';
import { formatDateTime } from '../kds';
import ProfileList from './components/ProfileList';
import { CurrencyAmount } from 'src/containers/currency';

interface IProps {}

const ViewCustomer: React.FC<IProps> = ({}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const symbol = useSelector(
    ({ currencyData }: RootState) => currencyData.myCurrencyData?.symbol ?? 'Rs.'
  );

  const [query, setQuery] = React.useState('');
  const [orderData, setOrderData] = useState<any>([]);
  const { customerId } = useParams();
  const {
    isLoading,
    data: customerData,
    errorText,
  } = useFetch(`/users/one/${customerId}`);
  const startDate = useSelector(
    ({ customerData }: RootState) => customerData.customerStartDate
  );
  const endDate = useSelector(
    ({ customerData }: RootState) => customerData.customerEndDate
  );
  const [orderLoading, setOrderLoading] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openDisc = Boolean(anchorEl);
  const handleClickDiscMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const [paymentStatus, setPaymentStatus] = useState(payment_status[0]);
  const [selectedRowsAll, setSelectedRows] = useState([]);

  const fetchData = useCallback(async (querySend: string) => {
    try {
      setOrderLoading(true);
      const res = await Service.get(`/users/history/${customerId}${querySend}`);
      const data = await res?.data;
      setOrderData(data);
      setOrderLoading(false);
    } catch (err) {
      setOrderLoading(false);
    }
  }, []);

  let statusJoined = [].map((item: any) => item.categoryInfo.id).join(',');
  useEffect(() => {
    const date = `from=${startDate?.toISOString()}&to=${endDate?.toISOString()}`;
    if (!startDate || !endDate) return;
    fetchData(
      `?${date}&categories=${statusJoined}&type=${paymentStatus.value}`
    );
  }, [startDate, endDate, paymentStatus]);

  const history = orderData?.userReceipts ?? [];

  const searchDesignationData = useMemo(() => {
    if (!history || Object.keys(history).length === 0) return [];

    return history.filter((item: any) => {
      if (query === '') return true;
      return (
        item?.name?.toLowerCase().includes(query.toLowerCase()) ||
        item?.phone.includes(query)
      );
    });
  }, [query, history]);

  const tableColumn = [
    {
      Header: 'Date',
      accessor: 'createdAts',
      Cell: (row: any) => (
        <p className="text-text-black">
          {' '}
          {formatDateTime(row?.cell?.row?.original?.createdAt)}
        </p>
      ),
    },
    {
      Header: 'Order ID',
      accessor: 'referenceNumber',
    },
    {
      Header: 'From',
      accessor: 'oarigin',
      Cell: (row: any) => (
        <p className="text-text-black">
          {' '}
          {row?.cell?.row?.original?.origin?.split('_')?.join(' ')}
        </p>
      ),
    },
    {
      Header: 'Type',
      accessor: 'orderTypse',
      Cell: (row: any) => (
        <p className="text-text-black">
          {' '}
          {row?.cell?.row?.original?.orderType?.split('_')?.join(' ')}
        </p>
      ),
    },
    {
      Header: 'Amount',
      accessor: 'totals',
      Cell: (row: any) => {
        return <span><CurrencyAmount amount={row?.cell?.row?.original?.total}/></span>;
      },
    },
    {
      Header: '',
      accessor: 'subTotalss',
      Cell: (row: any) => {
        return PaymentStatusButton(row?.cell?.row?.original?.status);
      },
    },
    {
      Header: 'Action',
      accessor: 'action',
      Cell: (row: any) => (
        <div className="flex items-center">
          <div
            className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
            onClick={() => navigate(`/orders/${row?.cell?.row?.original?.id}`)}
          >
            <AiOutlineEye color="#4062FF" />
          </div>
        </div>
      ),
    },
  ];

  const PaymentTypeSelector = () => {
    return (
      <div className="flex gap-2 items-center">
        <Button
          text={
            <div className="flex items-center justify-between w-[120px]">
              <span>{paymentStatus.title}</span>
              <BiChevronDown size={18} />
            </div>
          }
          aria-controls={openDisc ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={openDisc ? 'true' : undefined}
          // @ts-ignore
          onClick={handleClickDiscMenu}
        />
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={openDisc}
          onClose={() => setAnchorEl(null)}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          PaperProps={{
            style: {
              boxShadow: 'none',
              marginTop: '5px',
              border: '1px solid #4062FF',
              height: 'fit-content',
              backgroundColor: '#FFFFFF',
              overflow: 'hidden',
            },
          }}
        >
          {payment_status?.map((each: any, i: number) => (
            <div
              key={'payment' + i}
              className={`font-Outfit px-2 py-2 hover:bg-almost-white font-normal text-[14px] leading-6  cursor-pointer `}
              onClick={() => {
                setPaymentStatus(payment_status[i]);
                setAnchorEl(null);
              }}
            >
              {each.title}
            </div>
          ))}
        </Menu>
      </div>
    );
  };

  const DateRangePickerWithTime = () => {
    return (
      <div className="text-black flex flex-row items-center">
        <Datepicker
          name="date"
          className="w-[fit] appearance-none rounded-xl text-text-black
                placeholder:capitalize py-3 block placeholder:text-sm px-3 text-sm
                focus-within:outline-0 border-solid border border-primary"
          locale="en-US"
          selected={startDate}
          onChange={(date) => {
            if (startDate?.getTime() !== date?.getTime()) {
              dispatch(setCustomerDate({ startDate: date, endDate }));
            }
          }}
          startDate={startDate}
          endDate={endDate}
          selectsStart
          showTimeSelect
          timeIntervals={15}
          dateFormat="MMM d, yyyy h:mm aa"
          placeholderText="Select start date and time"
        />
        <span className="mx-1">-</span>
        <Datepicker
          name="date"
          className="w-[fit] appearance-none rounded-xl text-text-black
                placeholder:capitalize py-3 block placeholder:text-sm px-3 text-sm
                  focus-within:outline-0 border-solid border border-primary"
          locale="en-US"
          selected={endDate}
          onChange={(date) => {
            if (startDate?.getTime() !== date?.getTime()) {
              dispatch(setCustomerDate({ startDate, endDate: date }));
            }
          }}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          showTimeSelect
          timeFormat="HH:mm"
          timeIntervals={15}
          timeCaption="Time"
          dateFormat="MMM d, yyyy h:mm aa"
          placeholderText="Select end date and time"
        />
      </div>
    );
  };

  return (
    <>
      <div
        className="flex items-center space-x-4 "
        onClick={() => window?.history?.go(-1)}
      >
        <HiArrowNarrowLeft size={25} />
      </div>
      {isLoading && <Loader />}
      {customerData && (
        <div className="flex flex-col xl:flex-row gap-10 mb-5 text-[black]">
          {/* left */}
          <div className="w-full xl:w-[332px] flex xl:flex-col gap-2">
            <Card className="w-full xl:w-auto">
              <div className="flex items-center justify-center flex-col">
                <Avatar
                  src={customerData?.personalInfoData?.image}
                  style={{ width: 116, height: 116 }}
                />
                <h5 className="capitalize mt-3 text-base font-semibold">
                  {customerData?.personalInfoData?.name}
                </h5>
              </div>
              <ProfileList
                icon={<AiOutlineCompass color="#4062FF" size={20} />}
                title="Total Visits"
                count={customerData?.personalInfoData?.totalVisits}
              />
              <ProfileList
                icon={<BiDollarCircle color="#4062FF" size={20} />}
                title="Total Amount Spent"
                count={
                  customerData?.totalSpent === null
                    ? 0
                    : symbol + ' ' + customerData?.personalInfoData?.totalSpent
                }
              />
              <div className="mt-5" />
              {customerData?.personalInfoData?.email && (
                <ProfileList
                  icon={<BsEnvelope size={20} className="text-light-grey" />}
                  title={customerData?.personalInfoData?.email}
                />
              )}
              <ProfileList
                icon={<IoCallOutline size={20} className="text-light-grey" />}
                title={customerData?.personalInfoData?.phone}
              />
            </Card>
            <Card className="w-full xl:w-auto">
              <ProfileList
                icon={<CashRegister color="#4062FF" size={20} />}
                title="User Receipts Total"
                count={orderData?.userReceiptsTotal ?? '-'}
              />
              <ProfileList
                icon={<BiDollarCircle color="#4062FF" size={20} />}
                title="User Receipts Total Paid"
                count={orderData?.userReceiptsTotalPaid ?? '-'}
              />
              <ProfileList
                icon={<AiTwotoneAlert color="#4062FF" size={20} />}
                title="User Receipts Remaining"
                count={orderData?.userReceiptsRemaining ?? '-'}
              />
            </Card>
          </div>
          {/* right */}
          <div className="w-full max-w-[850px]">
            <Card className="">
              <div className="flex justify-between">
                {selectedRowsAll.length > 0 ? (
                  <Button
                    type="submit"
                    text={'Make payment'}
                    variant="primary"
                    onClick={() => {
                      navigate('/payment/admin/multiple', {
                        state: { orders: selectedRowsAll },
                      });
                    }}
                  />
                ) : (
                  <div className="flex items-center w-full justify-between">
                    <p className="text-text-black font-semibold text-lg ">
                      Order History
                    </p>
                    <div className="flex gap-2">
                      {PaymentTypeSelector()}
                      {DateRangePickerWithTime()}
                    </div>
                  </div>
                )}
              </div>
              <div className="h-fit overflow-x-auto px-3 mt-3 ">
                <Table
                  loading={isLoading || orderLoading}
                  pagination={true}
                  tableColumn={tableColumn}
                  tableData={searchDesignationData}
                  showCheckbox={true}
                  onSelectRow={(selectedRows) => {
                    setSelectedRows(selectedRows);
                  }}
                />
              </div>
            </Card>
          </div>
        </div>
      )}
      {errorText && <div className="">something went wrong try again</div>}
    </>
  );
};

export default React.memo(ViewCustomer);
